import StatisticCard from "./StatisticCard";
import { getLang } from "../../../store/uiStore";
import SectionCard from "../components/common/SectionCard";

export default function OverviewSection({
    data,
    clinics = [],
    clinicsLoading = false,
    clinicsExpanded = false,
    onToggleClinics,
}) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Общая информация" : "Маълумоти умумӣ",
        clinics: lang === "ru" ? "Всего клиник" : "Ҳамагӣ муассисаҳо",
        reports: lang === "ru" ? "Всего отчетов" : "Ҳамагӣ ҳисоботҳо",
        clickHint: lang === "ru" ? "Нажмите, чтобы увидеть список клиник" : "Барои дидани рӯйхати муассисаҳо пахш кунед",
        hide: lang === "ru" ? "Свернуть список" : "Пинҳон кардани рӯйхат",
        loading: lang === "ru" ? "Загрузка списка..." : "Рӯйхат бор шуда истодааст...",
        empty: lang === "ru" ? "Клиники по выбранным фильтрам не найдены." : "Муассисаҳо мувофиқи филтрҳо ёфт нашуданд.",
    };

    if (!data) return null;

    return (
        <SectionCard title={tr.section} icon="bar-chart-line" className="analytics-overview-section">
            <div className="row g-3">
                <div className="col-lg-6">
                    <div
                        role="button"
                        tabIndex={0}
                        aria-expanded={clinicsExpanded}
                        onClick={onToggleClinics}
                        onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                onToggleClinics();
                            }
                        }}
                        className="analytics-clinics-toggle"
                        style={{ cursor: "pointer", height: "100%" }}
                        title={tr.clickHint}
                    >
                        <StatisticCard title={tr.clinics} value={data.total_clinics} />
                        <div className="small text-primary mt-2 px-1 analytics-clinics-hint">
                            <span aria-hidden="true">{clinicsExpanded ? "▲" : "▼"}</span>{" "}
                            {clinicsExpanded ? tr.hide : tr.clickHint}
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <StatisticCard title={tr.reports} value={data.total_reports} />
                </div>
            </div>

            {clinicsExpanded && (
                <div className="mt-3 p-3 bg-white border rounded-3 analytics-clinics-list" aria-live="polite">
                    <div className="fw-semibold mb-2">
                        {tr.clinics}: {clinicsLoading ? "…" : clinics.length}
                    </div>
                    {clinicsLoading ? (
                        <div className="text-muted small">{tr.loading}</div>
                    ) : clinics.length ? (
                        <ol className="mb-0 ps-3">
                            {clinics.map((clinic) => (
                                <li key={clinic.id} className="py-1">{clinic.name}</li>
                            ))}
                        </ol>
                    ) : (
                        <div className="text-muted small">{tr.empty}</div>
                    )}
                </div>
            )}
        </SectionCard>
    );
}
